import type { Kitchen } from '@rta/rta-blueprint-library';

export type NeedsFlatTrimPageParams = {
	kitchen: Kitchen;
};

export const needsFlatTrimPage = (params: NeedsFlatTrimPageParams): boolean => {
	const { kitchen } = params;
	const { islands } = kitchen.design;

	for (let i = 0; i < islands.children.length; i++) {
		const island = islands.children[i];
		const panelTrims = island.panelTrims?.children ?? [];

		if (panelTrims.some((panelTrim) => panelTrim.isFlat)) {
			return true;
		}
	}

	return false;
};
